import React from 'react';
import css from './FormspreeSection.module.css';

const FormspreeSection = props => {
  const { sectionId, className, rootClassName, background, fieldOptions } = props;

  return (
    <div
      id={sectionId}
      className={className}
      rootclassname={rootClassName}
      background={background}
      options={fieldOptions}
    >
      <div className={css.formSection}>
        <h2 className={css.title}>Contact Us</h2>
        <p className={css.description}>Have questions? We'd love to hear from you.</p>

        <form
          className={css.form}
          action="https://formspree.io/f/mvggvzld"
          method="POST"
        >
          <div className={css.field}>
            <label className={css.label}>
              Your email:
              <input 
                type="email" 
                name="email" 
                className={css.input}
                required 
              />
            </label>
          </div>
          <div className={css.field}>
            <label className={css.label}>
              Your message:
              <textarea 
                name="message" 
                className={css.textarea}
                required 
              />
            </label>
          </div>
          <button type="submit" className={css.submitButton}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormspreeSection; 